/** @format */

import database from '../firebase/config';
import { observable, action } from 'mobx';
import ResourceStore from './classes/ResourceStore';

class CarPartsStore extends ResourceStore {
  @observable ref = `parts`;
  @observable currentReqPart = {};
  @observable defaultItem = {
    uid: null,
    data: { uid: null, name: '', whCode: '' },
  };
  @observable whZones = [];
  @observable tableKeys = [
    { label: 'NOME', prop: 'data.name' },
    { label: 'ZONA MAGAZZINO', prop: 'data.whCode' },
  ];
  @observable filter = {
    status: 'all',
    rules: {
      all: { label: 'Tutti', name: 'all' },
      CARLEG: {
        label: 'Carrozzeria leggera',
        name: 'data.whCode',
        value: 'CARLEG',
      },
      LAMIER: { label: 'Lamierati', name: 'data.whCode', value: 'LAMIER' },
      MECPES: {
        label: 'Meccanica pesante',
        name: 'data.whCode',
        value: 'MECPES',
      },
      MECLEG: {
        label: 'Meccanica leggera',
        name: 'data.whCode',
        value: 'MECLEG',
      },
    },
  };
  @observable search = {
    value: '',
    attributes: ['data.name', 'data.whCode'],
  };

  @action fetchWhZones = () => {
    let whZonesRef = database
      .ref('/whZones')
      .orderByChild('data/status')
      .equalTo('attivo');

    whZonesRef.once('value', whZonesSnapshot => {
      this.whZones = [];
      let whZonesValues = whZonesSnapshot.val();
      whZonesValues.forEach(whZone => {
        this.whZones.push({
          text: whZone.data.whZoneName,
          value: whZone.data.whCode,
        });
      });
    });
  };

  @action handleInputChange = (value, name) => {
    this.edit.currentItem.data[name] = value;
  };
}

export default new CarPartsStore();
